var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seting"},[_c('van-button',{attrs:{"type":"danger","block":""},on:{"click":_vm.loginOut}},[_vm._v("退出登录")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }